import { render, staticRenderFns } from "./media-select.vue?vue&type=template&id=3abf8de3"
import script from "./media-select.vue?vue&type=script&lang=js"
export * from "./media-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports